const STORAGE_VERSION = 1;
export const LAST_VISITED_PATH_KEY = `lula-last-visited-path-v${STORAGE_VERSION}`;
export const LAST_VISITED_PATH_TTL_MS = 1000 * 60 * 60; // 1 hour in milliseconds
